import React from 'react';
import {
    Card,
    WarningModal,
    SimpleTable,
    SimpleTableHeader,
    IEmptySectionProps,
} from 'components';
import { IExpertQualification } from 'components/models';
import { IApiError } from '_helpers/ApiConnector/types';
import qualificationPlaceholderIcon from '../../assets/svg/ac/empty_certificate_icon.svg';
import moment from 'moment';

const ExpertQualifications = ({
    qualificationsList,
    cardTitle,
    cardCategory,
    apiError,
    onQualificationListRowClick,
    onHideErrorModal,
    showErrorModal,
}: IProps) => {
    const emptyDataProps: IEmptySectionProps = {
        placeholderTitle: 'Нет подтвержденных специальностей',
        placeholderText: 'Здесь будут отображаться подтвержденные специальности',
        placeholderButtonText: '',
        placeholderIcon: qualificationPlaceholderIcon,
    };

    const listTableHeaders: SimpleTableHeader[] = [
        { title: 'СПЕЦИАЛЬНОСТЬ', columnStyles: { width: '100%' } },
        { title: 'СТАЖ (ЛЕТ)', columnStyles: { minWidth: '12rem' } },
    ];

    const listTableRows = qualificationsList ? qualificationsList.map(({
         title, experienceStartDate, id, regNumber,
    }, i) => ({
        id: id || i,
        columns: [
            `${regNumber} - ${title}`,
            moment().diff(experienceStartDate, 'year'),
        ],
    })) : [];

    const handleListRowClick = (examApplicationId: string | number) => {
        if (onQualificationListRowClick && qualificationsList) {
            onQualificationListRowClick(`${examApplicationId}`);
        }
    };

    return (
        <Card
          cardClassName="border-0"
          withoutPadding
          title={cardTitle || 'Специальности'}
          category={cardCategory || 'Список всех специальностей'}
          apiError={apiError}
        >
            <SimpleTable
              tableHeaders={listTableHeaders}
              tableRows={listTableRows}
              handleRowClick={handleListRowClick}
              {...emptyDataProps}
            />

            {apiError && showErrorModal !== undefined && onHideErrorModal ? (
                <WarningModal
                  title={apiError.message}
                  onHide={onHideErrorModal}
                  show={showErrorModal}
                />
            ) : null}
        </Card>
    );
};

export interface IProps {
    qualificationsList: IExpertQualification[] | null;
    cardTitle?: string;
    cardCategory?: string;
    apiError: IApiError | null;
    showErrorModal?: boolean;
    onHideErrorModal?: () => void;
    onQualificationListRowClick?: (examApplicationId: string) => void;
}


export default ExpertQualifications;
